import React, { useCallback } from 'react';
import { useAsync } from 'react-async';

import AppLoadingContainer from '../../components/AppLoadingContainer';
import { api } from '../../core/api';
import { ClassifiersContextProvider } from './ClassifiersContext';

const ClassifiersProvider: React.FC = ({ children }) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const promiseFn = useCallback(api.classifiers.getClassifiers, []);
  const { data, isLoading } = useAsync({
    promiseFn,
    onReject: (error) => Promise.reject(error),
  });

  if (isLoading) {
    return <AppLoadingContainer />;
  }

  return <ClassifiersContextProvider classifiers={data}>{children}</ClassifiersContextProvider>;
};

export default ClassifiersProvider;
